module.exports = __webpack_public_path__ + "static/media/mlh-logo.bc5cfd3a.svg";